import React from "react";
import { ChatTheme, QuickAction } from "./types";
import { QUICK_ACTIONS } from "./chat-constants";

// ============================================================================
// Props
// ============================================================================

interface QuickActionsProps {
  onAction: (action: QuickAction) => void;
  disabled?: boolean;
  theme: ChatTheme;
  centered?: boolean;
}

// ============================================================================
// Component
// ============================================================================

/**
 * Quick action buttons for common chat prompts.
 */
export const QuickActions: React.FC<QuickActionsProps> = ({
  onAction,
  disabled = false,
  theme,
  centered = false,
}) => {
  return (
    <div className={`flex gap-2 flex-wrap ${centered ? "justify-center" : ""}`}>
      {QUICK_ACTIONS.map((action) => (
        <button
          key={action.id}
          onClick={() => onAction(action)}
          disabled={disabled}
          className={`
            flex items-center gap-1.5 rounded-xl px-3.5 py-2
            text-xs font-medium transition-all duration-200
            bg-white/[0.04] border border-white/[0.08]
            ${theme.textSecondary}
            disabled:opacity-40 disabled:cursor-not-allowed
            hover:bg-white/[0.08] hover:border-accent/30 hover:text-accent
          `}
        >
          {action.icon}
          <span>{action.label}</span>
        </button>
      ))}
    </div>
  );
};

QuickActions.displayName = "QuickActions";

export default QuickActions;
